import emptySplitApi from "./emptySplitApi";

export const Permissions = {
  ExamsCreate: "exams.create",
  ExamsUpdate: "exams.update",
  ExamsRead: "exams.read",
  GovernmentIDRead: "government-id.read",
  GovernmentIDContentRead: "government-id.content.read",
  GovernmentIDReview: "government-id.review",
} as const;
type PermissionsKey = keyof typeof Permissions;
export type Permission = (typeof Permissions)[PermissionsKey];
export type PermissionAndDescription = {
  permission: Permission;
  description: string;
};

const extendedApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPermissions: builder.query<PermissionAndDescription[], undefined>({
      query: () => ({
        url: `${location.origin}/ies/api/security/permissions`,
        headers: {
          Accept: "application/vnd.redhat.v2+json",
        },
      }),
    }),
  }),
});

export const { useGetPermissionsQuery, useLazyGetPermissionsQuery } =
  extendedApi;
